var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffc107"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.9383 14.6667c-.0249 0-.0504-.0012-.0753-.0047h-11.82154c-.02431.0029-.04863.0041-.07295.0041-.31315 0-.57708-.2236-.6269-.532-.0255-.1572.00831-.3167.09549-.4496l5.98491-11.96858c.17259-.34577.42821-.38255.53022-.38255.12692 0 .36416.04982.53023.38255l5.98494 11.96918c.1844.2806.1138.6655-.1596.8624-.1085.0777-.236.1192-.3695.1192zm-11.97928-.6987c-.00711.0137-.01482.0273-.02431.0398-.00712.0101-.00949.0201-.00771.0308.00355.0214.02253.0344.03914.0344.02313-.0035.03914-.0047.05516-.0047h11.8619c.016 0 .032.0012.048.0041h.0048c.0118 0 .0183-.0023.0249-.0071.0183-.013.0225-.0385.0095-.0569-.0089-.0119-.0172-.0255-.0244-.0398l-5.99377-11.98757z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.95223 10.8092c-.16369 0-.29654-.1328-.29654-.2965v-4.15167c0-.1637.13285-.29655.29654-.29655.1637 0 .29655.13285.29655.29655v4.15167c0 .1637-.13285.2965-.29655.2965z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.96054 12.292c-.24436-.0006-.44304-.1892-.45253-.43-.00238-.1228.04092-.2361.12277-.3221.08184-.086.19216-.1352.31078-.137.25147.0048.4466.194.45549.4306.00238.1228-.04092.2361-.12277.3221-.08184.0859-.19216.1346-.31078.137 0 0-.00178-.0006-.00296-.0006z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.7b55a7ee6c82780d403e545ca36aa133.svg";
export { ForwardRef as ReactComponent };